import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Mixpanel from 'mixpanel-browser';
import QuizHeader from '~/components/QuizHeader';
import Quiz from '~/core/helpers/quiz';
import Button from '~/components/Button';
import Spacer from '~/components/Spacer';

import './PersonalGrowth.styles.css';
import { NavigationPath, ScreenProps } from '~/core/dto/navigationDTO';

const PersonalGrowth: FC<ScreenProps> = ( { type } ) => {

  const navigate = useNavigate();
  const routeName = `PersonalGrowth-${type}`;

  const questions = Quiz.getQuestions( 'parent' );
  const currentYear = new Date().getFullYear();
  const confidentCashManagerDate = new Date();
  confidentCashManagerDate.setDate( confidentCashManagerDate.getDate() + 30 );

  const getNextMonth = ( monthsFromDate: number ) => {

    const date = new Date( confidentCashManagerDate );
    date.setMonth( date.getMonth() + monthsFromDate );

    return date.toLocaleString( 'en-EN', { month: 'short' } );

  };

  const onContinue = () => {

    Mixpanel.track( routeName, { state: 1 } );

    navigate( NavigationPath.FinancialIQ );

  };

  useEffect( () => {

    Mixpanel.track( routeName, { state: 0 } );

  }, [] );

  return (
    <div className="container">
      <QuizHeader type="parent" progress={( questions.length ) / ( questions.length + 1 )} />
      <div className="scrollContainer personalGrowth">
        <Spacer size={24} />
        <h1 className="textCenter">Your child’s personal wealth growth challenge</h1>
        <Spacer size={16} />
        <p className="textCenter">Based on your answers, we expect your child to gain necessary skills of</p>
        <Spacer size={48} />
        <h3>
          Confident Cash Manager by
          <br />
          {`${getNextMonth( 0 )}, ${currentYear}`}
        </h3>
        <Spacer size={36} />
        <div className="containerPadding">
          <div className="chart flexRow justifySpaceBetween">
            <div className="chartItem">
              <div className="chartDrawing">
                <div className="tooltip">
                  <p>Beginner</p>
                </div>
              </div>
              <p>{getNextMonth( -2 )}</p>
            </div>
            <div className="chartItem">
              <div className="chartDrawing" />
              <p>{getNextMonth( -1 )}</p>
            </div>
            <div className="chartItem">
              <div className="chartDrawing">
                <div className="tooltip">
                  <p>
                    Confident
                    <br />
                    Cash Manager
                  </p>
                </div>
              </div>
              <p>{getNextMonth( 0 )}</p>
            </div>
            <div className="chartItem">
              <div className="chartDrawing" />
              <p>{getNextMonth( 1 )}</p>
            </div>
          </div>
        </div>
      </div>
      <Spacer size={16} />
      <Button onPress={onContinue}>Continue</Button>
      <Spacer size={16} />
    </div>
  );

};

export default PersonalGrowth;
